import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    height: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: 16,
    paddingTop: '3rem',
    gap: '2.5rem',
  },
  textContent: {
    width: '90vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '0.75rem',
    
    '& > p' : {
      fontSize: '1.5rem',
    },
  },
  tabWrapper: {
    width: '90vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    borderRadius: '5px',
    border: `solid 1px ${Colors.lightGray}`,
    padding: '1.25rem',
    backgroundColor: Colors.lightGray,
  },
  panel: {
    width: '100%',
    height: '100%',
    borderRadius: '5px',
    border: `solid 1px ${Colors.gray}`,
    padding: '1.25rem',
    backgroundColor: Colors.white,
  },
  dataTable: {
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    borderRadius: '5px 5px 0 0',
    width: '100%',
    minWidth: '900px',
    fontSize: '1.8rem',

    '& thead tr:first-child': {
      '& th:first-child': {
        borderRadius: '4px 0 0 0',
      },
      '& th:last-child': {
        borderRadius: '0 4px 0 0',
      },
    },

    '& thead tr': {
      backgroundColor: theme.palette.grey[800],
      color: '#FFFFFF',
      textTransform: 'uppercase',

      '& th': {
        padding: '5px 5px',
        textAlign: 'center',
        fontSize: '1.2rem',
        width: 120,
      },

      '& middle-col': {
        whiteSpace: 'break-spaces',
        minWidth: 50,
        maxWidth: 52,
      },
    },

    '& tbody tr': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',

      '&:nth-child(even)': {
        backgroundColor: '#EFEFEF',
      },

      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
      },

      '& td': {
        '@media only screen and (min-width : 1920px)': {
          padding: '0.4rem 0.3rem',

        },
        '@media only screen and (max-width : 1920px)': {
          padding: '0.2rem 0.15rem',

        },
        fontSize: '1.2rem',
        textAlign: 'center',
      },

      '& td:nth-child(-n+5)': {
        fontSize: '1.3rem',
        '@media only screen and (min-width : 1920px)': {
          width: 300,
          height: 35,
        },
        '@media only screen and (max-width : 1920px)': {
          width: 220,
          height: 0,
        },
      },
    },

    '& tfoot tr': {
      '& td': {
        padding: 10,
      },
    },
  },
}))

export default styles
